import { useEffect, useState } from "react";
import { fetchAllProviders } from "../../config/LiveApi";
import "./Modal.css";
import { useSelector } from "react-redux";

const ViewModal = ({ onClose, formData }) => {
  const [providerOptions, setProviderOptions] = useState([]);
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const getProviderNameById = (id) => {
    const provider = providerOptions.find((provider) => provider.id === id);
    return provider ? provider.providerName : "N/A";
  };

  useEffect(() => {
    const getProviders = async () => {
      try {
        const response = await fetchAllProviders(token);
        setProviderOptions(response.data.providers);
      } catch (error) {
        console.error("Error fetching providers:", error);
      }
    };

    getProviders();
  }, [token]);

  const isAdmin = formData.role === "admin";

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>

        <h3>Hello, {formData.name}!</h3>
        <form>
          <p className="label-data">Name</p>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData?.name || ""}
            readOnly
          />

          <p className="label-data">Phone Number</p>
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={formData?.phoneNumber || ""}
            readOnly
          />
          <p className="label-data">Email</p>
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={formData?.email || ""}
            readOnly
          />

          {isAdmin && (
            <>

          <p className="label-data">Payin Provider Name</p>
          <input
            type="text"
            name="payinProviderName"
            placeholder="Payin Provider Name"
            value={getProviderNameById(formData.payinProviderID)}
            readOnly
          />

          <p className="label-data">Payout Provider Name</p>
          <input
            type="text"
            name="payoutProviderName"
            placeholder="Payout Provider Name"
            value={getProviderNameById(formData.payoutProviderID)}
            readOnly
          />

          <p className="label-data">Provider Payin Comission</p>
          <input
            type="text"
            name="providerPayinComission"
            placeholder="Provider PayIn Comission"
            value={formData.providerPayinComission || 0}
            readOnly
          />

          <p className="label-data">Provider Payout Comission</p>
          <input
            type="text"
            name="providerPayoutComission"
            placeholder="Provider PayOut Comission"
            value={formData.providerPayoutComission || 0}
            readOnly
          />

          <p className="label-data">Total Payin Comission</p>
          <input
            type="text"
            name="totalPayinComission"
            placeholder="Total PayIn Comission"
            value={parseFloat(formData.totalPayinComission || 0).toFixed(3)}
            readOnly
          />

          <p className="label-data">Total Payout Comission</p>
          <input
            type="text"
            name="totalPayoutComission"
            placeholder="Total Payout Comission"
            value={parseFloat(formData.totalPayoutComission || 0).toFixed(3)}
            readOnly
          />
          
          <p className="label-data">Rolling Reserve (%)</p>
          <input
            type="text"
            name="rollingReserve"
            placeholder="Rolling Reserve"
            value={formData.rollingReserve || ""}
            readOnly
          />

          <p className="label-data">Rolling Reserve Days</p>
          <input
            type="text"
            name="rollingReserveDays"
            placeholder="Rolling Reserve Days"
            value={formData.rollingReserveDays || ""}
   
          />
          <p className="label-data">Penalty Amount</p>
                <input
                  type="text"
                  name="penaltyAmount"
                  placeholder="Rolling Reserve Days"
                  value={formData.penaltyAmount}
                  readOnly
          />
          </>
        )}
        </form>
      </div>
    </div>
  );
};

export default ViewModal;
